module.exports = __webpack_public_path__ + "static/images/fa-regular-400.45f938a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/fa-regular-400.svg
// module id = ykGC
// module chunks = 12